let url = location.search.replace('?', '');
let urlParse = url.split('&');
urlParse = urlParse.filter(pair => {
    let query = pair.split('=');
    if(!query[0].startsWith("_")){
        return query;
    }
});
let urlParams = false;
if(urlParse.length >= 1){
    if(urlParse[0].trim()){
        urlParams = true;
    }
    if(urlParams){
        document.getElementById('filtz__product-loading-div').innerHTML='<div class="loader-body"><div class="loader"></div></div>';
    }

}
